import { createReducer } from '@reduxjs/toolkit';

import { disconnected } from '../thunks/subscriptions.thunks';
import {
  pipeAdded,
  pipeUpdated,
  pipeRuntimeUpdated,
  pipeLoaded,
  pipesLoadAllFinished,
  pipesLoadAllFailed,
  actionStatusSet,
  pipePartiallyLoaded,
  pipesUpdated,
  pipesAdded,
  pipesDeleted,
  pipesRemoved,
} from '../thunks/pipes.thunks';

import { decoratePipe } from './decoratePipe';

import type { PipeMap } from '../../types/pipes.types';

// -----------------------------------------------------------------------------

type State = PipeMap;
const initialState: State = {};

export const pipesReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(disconnected, () => initialState)
    .addCase(pipeAdded, (state, action) => {
      state[action.payload._id] = decoratePipe(action.payload);
    })
    .addCase(pipeUpdated, (state, action) => {
      state[action.payload.pipe._id] = decoratePipe(action.payload.pipe);
    })
    .addCase(pipesAdded, (state, action) => {
      action?.payload?.pipes.forEach((pipe) => {
        state[pipe._id] = decoratePipe(pipe);
      });
    })
    .addCase(pipesUpdated, (state, action) => {
      action?.payload?.pipes.forEach((pipe) => {
        state[pipe._id] = decoratePipe(pipe);
      });
    })
    .addCase(pipesDeleted, (state, action) => {
      action?.payload?.pipes.forEach((pipe) => {
        delete state[pipe._id];
      });
    })
    .addCase(pipeRuntimeUpdated, (state, action) => {
      if (state[action.payload.id]) {
        state[action.payload.id].runtime = action.payload.runtime;
      }
    })
    .addCase(pipeLoaded, (state, action) => {
      state[action.payload.pipe._id] = decoratePipe(action.payload.pipe);
    })
    .addCase(pipePartiallyLoaded, (state, action) => {
      const types = [];

      if (action.payload.pipe.config) {
        types.push('config');
      }

      if (action.payload.pipe.runtime) {
        types.push('runtime');
      }

      if (action.payload.pipe.storage) {
        types.push('storage');
      }

      if (action.payload.pipe.graph) {
        types.push('graph');
      }

      types.forEach((t) => {
        (state[action.payload.id] as any)[t] = (action.payload.pipe as any)[t];
      });
    })
    .addCase(pipesLoadAllFinished, (state, action) => {
      let newState: State = {};
      for (let i = 0; i < action.payload.length; i++) {
        newState[action.payload[i]._id] = decoratePipe(action.payload[i]);
      }
      return newState;
    })
    .addCase(pipesLoadAllFailed, () => initialState)
    .addCase(actionStatusSet, (state, action) => {
      action.payload.forEach((p) => {
        if (state[p.id]) {
          state[p.id].actionStatus.status = p.state;
        }
      });
    })
    .addCase(pipesRemoved, (state, action) => {
      action.payload.forEach((p) => {
        delete state[p.id];
      });
    })
);
